<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <!-- 基本信息 -->
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime.sync="activityStartTime"
            :defaultActivityEndTime.sync="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :needNonMember="false"
            :activityId="76"
            :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- 活动设置 -->
          <jd-title label="活动设置"></jd-title>
          <div class="mt20">
            <el-form-item required label="活动类型:">
              <el-radio-group
                :disabled="isStartEdit"
                v-model="ruleDTO.activityType"
                @change="handleActivityTypeChange"
              >
                <el-radio :label="1">入会周年</el-radio>
                <el-radio :label="2">
                  自定义活动
                  <el-input
                    style="width: 345px"
                    :disabled="ruleDTO.activityType == 1"
                    v-model="ruleDTO.customActivityName"
                    show-word-limit
                    :maxlength="20"
                    placeholder="庆典名称，如店铺五周年庆典、会员日大促 "
                  />
                </el-radio>
                <el-tooltip class="item" effect="dark" placement="top">
                  <template slot="content">
                    <div>
                      入会周年庆，每位用户将在其个人入会周年日开奖（千人千面）
                    </div>
                    <div>
                      自定义活动，所有用户将在您设定的统一日期开奖（如店庆当天）
                    </div>
                  </template>
                  <jd-button type="blueText">活动类型说明</jd-button>
                </el-tooltip>
              </el-radio-group>
            </el-form-item>
            <!-- <div v-if="ruleDTO.activityType == 2">
              <el-form-item label="自定义时间:" required>
                <el-date-picker
                  prefix-icon="no_icon"
                  type="date"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  v-model="ruleDTO.customActivityTime"
                  placeholder="选择日期"
                  class="picker"
                  size="small"
                  :picker-options="pickerOption"
                  @change="handleDateChange"
                ></el-date-picker>
              </el-form-item>
            </div> -->
            <el-form-item label="任务获取:" required>
              <taskComponent
                :taskList.sync="taskDataList"
                :taskOrders.sync="taskOrderList"
                :copySteList.sync="taskLevelList"
                :mainText="mainText"
                :unit="unit"
                :isTrueEdit="true"
                :isDisabled="true"
                :isShowUnit="isShowUnit"
                :activityData="activityData"
                :activityStartTime="activityStartTime"
                :activityEndTime="activityEndTime"
                :hasSelectGoods="hasSelectGoods"
              />
            </el-form-item>
            <el-form-item label="是否展示回忆录:" required>
              <el-radio-group
                v-model="ruleDTO.showMemoryBook"
                @change="changeShowMemory"
              >
                <el-radio :label="true"
                  >是 <span class="mlr8">统计</span>
                  <el-select
                    v-model="ruleDTO.memoryBookTimeType"
                    placeholder="请选择"
                    :disabled="!ruleDTO.showMemoryBook"
                    style="width: 120px"
                    @change="changememoryBookTimeType"
                  >
                    <el-option
                      v-for="item in timeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <span class="ml8">的消费回忆录</span>
                </el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="回忆店铺数据:" v-if="ruleDTO.showMemoryBook">
              <orderShopCom
                :venderIds.sync="ruleDTO.venderIds"
                :isDisabled="backgroundOpacity"
                :isShowTips="false"
              />
            </el-form-item>
            <el-form-item label="赠送许愿币:" required v-if="ruleDTO.showMemoryBook">
              <el-radio-group
                v-model="ruleDTO.giftType"
                @change="changeunifiedCoins"
              >
              <div class="flex-c">
                <el-radio :label="1"
                  >统一设置
                  <span class="mr8">查看回忆录领取</span>
                  <el-input
                    class="w90"
                    v-model="ruleDTO.unifiedCoins"
                    placeholder="请输入"
                    :disabled="ruleDTO.giftType == 2"
                    @input="
                      ruleDTO.unifiedCoins = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        999999
                      )
                    "
                  ></el-input>
                  <span class="ml8">枚许愿币</span>
                </el-radio>
                <el-radio :label="2">按等级设置<span class="ml8">不同会员等级查看回忆录可赠送许愿币</span></el-radio>
              </div>
              </el-radio-group>
              <!-- <div class="text-red">不同会员等级查看回忆录可赠送许愿币</div> -->
              <jd-table
                class="w400"
                :tableData="lvCoinList"
                :tableInfo="vlTableInfo"
                :loading="lvLoading"
                v-if="ruleDTO.giftType == 2"
              >
                <template #lvCoinSlot="{ row }">
                  <el-input
                    v-model="row.lvCoin"
                    placeholder="请输入"
                    class="w90"
                    :max="999999"
                    :min="1"
                    :disabled="ruleDTO.giftType == 1"
                    @input="row.lvCoin = getNumberData(1, $event, 0, 1, 999999)"
                  ></el-input>
                  <span class="ml8">枚</span>
                </template>
              </jd-table>
            </el-form-item>
          </div>
          <!-- 奖品设置 -->
          <jd-title label="奖品设置"></jd-title>
          <div class="mt20">
            <el-form-item label="领奖有效期:" required v-if="ruleDTO.activityType == 1">
              <div class="flexc">
                <el-select
                  v-model="ruleDTO.celebrationType"
                  placeholder="请选择"
                  style="width: 140px"
                  @change="changecelebrationType"
                >
                  <el-option
                    v-for="item in commcelebrationTypeLList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <div v-if="ruleDTO.celebrationType == 4">
                  <span class="mlr8">从{{ commWinText }}前</span>
                  <el-input
                    v-model="ruleDTO.celebrationBeforeDays"
                    @input="
                      ruleDTO.celebrationBeforeDays = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        60
                      )
                    "
                    placeholder="请输入"
                    class="w90"
                  />
                  <span class="mlr8">天到{{ commWinText }}后</span>
                  <el-input
                    v-model="ruleDTO.celebrationAfterDays"
                    @input="
                      ruleDTO.celebrationAfterDays = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        60
                      )
                    "
                    placeholder="请输入"
                    class="w90"
                  />
                  天
                </div>
              </div>
            </el-form-item>
            <template v-else>
              <el-form-item label="抽奖有效期:" required>
                <el-radio-group v-model="ruleDTO.drawValidityType" :disabled="activityData.isStart">
                  <el-radio :label="0">活动期间内许愿成功都可抽奖</el-radio>
                  <el-radio :label="1">
                    <span>许愿成功后需在此时间内抽奖</span>
                    <el-date-picker
                      v-model="ruleDTO.drawStartTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      format="yyyy-MM-dd"
                      placeholder="开始时间"
                      class="ml8"
                      :picker-options="drawStartTimeOptions"
                      :disabled="ruleDTO.drawValidityType == 0 || activityData.isStart"
                      style="width: 150px"
                    ></el-date-picker>
                    <span class="ml8 mr8">-</span>
                    <el-date-picker
                      v-model="ruleDTO.drawEndTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      format="yyyy-MM-dd"
                      placeholder="结束时间"
                      :picker-options="drawEndTimeOptions"
                      :disabled="ruleDTO.drawValidityType == 0 || activityData.isStart"
                      style="width: 150px"
                    ></el-date-picker>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
            <el-form-item label="许愿池点亮限制:" required>
                <el-radio-group v-model="ruleDTO.lightingSettingType" :disabled="activityData.isStart">
                  <el-radio :label="0">仅可点亮一次</el-radio>
                  <el-radio :label="1">可点亮多次</el-radio>
                </el-radio-group>
              </el-form-item>
            <el-form-item label="中奖限制:">
              <div class="limit">
                <p>
                  抽奖有效期内<span class="c">每人每天</span>中奖不可超过
                  <el-input
                    v-model.number="ruleDTO.oneDayMaxRewardNumber"
                    class="ml8 mr8"
                    placeholder="不限制"
                    style="width: 80px"
                    @input="
                      ruleDTO.oneDayMaxRewardNumber = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                      )
                    "
                    :disabled="backgroundOpacity"
                  ></el-input>
                  次, <span class="c">累计</span>最多中奖
                  <el-input
                    v-model.number="ruleDTO.totalMaxRewardNumber"
                    class="ml8"
                    placeholder="不限制"
                    style="width: 80px"
                    @input="
                      ruleDTO.totalMaxRewardNumber = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                      )
                    "
                    :disabled="backgroundOpacity"
                  ></el-input>
                  次
                </p>
              </div>
            </el-form-item>
            <el-form-item label="奖品设置:" required>
              <jd-button type="blue" @click="addWishingPrize"
                >添加许愿池({{ wishingPrizeList.length }}/3)</jd-button
              >
              <jd-tip class="mt16">
                <div>
                  1、建议不同许愿池配置不同的奖品，用户可根据许愿池奖品来选择是否点亮
                </div>
                <div>
                  2、中奖率相加不得超过100%，且精确到小数点后五位，不足100%的时候剩余部分分配给“谢谢参与”，谢谢参与不展示。
                </div>
                <div>
                  3、若想许愿池百分百中奖，全部奖品中奖率合计需等于100%。
                </div>
                <div>
                  4、请大家切勿宣传100%中奖，为避免客诉，奖品中奖概率不建议设置为0；若奖品中奖概率一定要设置为0，一切后果由商家承担。
                </div>
              </jd-tip>
              <div class="mt16">
                <div
                  class="invite-box mb16"
                  v-for="(item, index) in wishingPrizeList"
                  :key="item.id"
                >
                  <div class="flex-spc-x">
                    <el-form-item
                      label="许愿池名称:"
                      required
                      label-width="100px"
                    >
                      <el-input
                        v-model="item.poolName"
                        show-word-limit
                        :maxlength="7"
                        placeholder="请输入"
                        class="w180"
                      ></el-input>
                    </el-form-item>
                    <div class="move-btn">
                      <jd-button
                        type="blueText"
                        v-if="wishingPrizeList.length > 1"
                        :disabled="isStartEdit && !item.isAdd"
                        @click="deleteWishingPrize(index)"
                        >删除</jd-button
                      >
                      <jd-button
                        type="blueText"
                        v-if="index != 0"
                        :disabled="isStartEdit && !item.isAdd"
                        @click="upWishingSetting(index)"
                        >上移</jd-button
                      >
                      <jd-button
                        type="blueText"
                        :disabled="isStartEdit && !item.isAdd"
                        v-if="index != wishingPrizeList.length - 1"
                        @click="downWishingSetting(index)"
                        >下移</jd-button
                      >
                    </div>
                  </div>
                  <el-form-item
                    label="许愿币配置:"
                    required
                    label-width="100px"
                  >
                    <span class="label-color mr8">消耗</span>
                    <el-input
                      v-model="item.consumeCoins"
                      class="w90"
                      @input="
                        item.consumeCoins = getNumberData(
                          1,
                          $event,
                          0,
                          1,
                          999999
                        )
                      "
                      placeholder="请输入"
                    ></el-input>
                    <span class="label-color ml8">枚许愿币点亮该许愿池</span>
                  </el-form-item>
                  <lotteryPrize
                    isShowLimit
                    :isShowSingleMax="ruleDTO.lightingSettingType == 1 ? true : false"
                    :limitBtnDisabled="false"
                    :prizeSettingList.sync="item.prizeSettingList"
                    :activityData="activityData"
                    :valueRow="valueRow"
                    :isShowLottery="isShowLottery"
                    :isShowAddBtn="isShowAddBtn"
                    :isShowTip="isShowTip"
                    :maxLimit="maxLimit"
                    :isShowIndex="isShowIndex"
                    :isShowMoveBtn="isShowMoveBtn"
                    :backgroundOpacity="backgroundOpacity"
                    :isDisabled="activityData.isStart"
                    :isShowDeleteBtn="isShowDeleteBtn"
                    :isAddPrize="isAddPrize"
                    :actType="76"
                    :actEndTime="ruleForm.endTime"
                    :minLimit="minLimit"
                    @addPrizeSetting="addPrizeSetting($event, index)"
                  >
                  </lotteryPrize>
                </div>
              </div>
            </el-form-item>
          </div>
          <!-- 活动页设置 -->
          <activityPageSettings
            isShowShopName
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            :templateId="templateId"
            :isShowDesignNumber="false"
            previewKey="url"
            templatekey="imageUrl"
            :widthNumber="750"
            :heightNumber="1650"
            :isCustomPreview="true"
            :downloadTemplateUrl="templateUrl"
            designSpecificationsUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/wishing-pool-rule.png"
            themeTitle="主题"
            :defaultRgb="currrentRgb"
            v-model="customerPaperwork"
            @selectTemplate="selectTemplate"
          >
            <template #customPreview>
              <wishingPoolDialog
                :ruleForm="ruleForm"
                :ruleDTO="ruleDTO"
                :backgroundImage="backgroundImage"
                :customerPaperwork="customerPaperwork"
                :templateObj="templateObj"
                :wishingPrizeList="wishingPrizeList"
                :getTimeText="getTimeText()"
              />
            </template>
            <template #otherSet>
              <!-- 自定义活动页设置 -->
              <el-form-item label="Tab设置：">
                <div class="upload-box">
                  <el-form-item label="Tab选中背景图：">
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => beforeUploadUI(file, 1)"
                        :on-success="(res) => handleUploadUI(res, 1)"
                      >
                        <div class="bg-wrap" v-if="customerPaperwork.tabUrl">
                          <img
                            :src="customerPaperwork.tabUrl"
                            class="bg-wrap-img"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueLine"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.tabUrl = ''"
                        class="ml16"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                      <span class="size-tip">尺寸建议：216*64px</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="Tab选中字体颜色：">
                    <div class="flexc-cen-x">
                      <el-color-picker
                        v-model="customerPaperwork.tabSelectedColor"
                        :disabled="backgroundOpacity"
                        class="colorPicker"
                      >
                      </el-color-picker>
                      <jd-button
                        class="ml16"
                        type="blueText"
                        :disabled="backgroundOpacity"
                        @click="customerPaperwork.tabSelectedColor = currrentRgb2"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                  <el-form-item label="Tab未选中字体颜色：">
                    <div class="flexc-cen-x">
                      <el-color-picker
                        v-model="customerPaperwork.tabUnSelectedColor"
                        :disabled="backgroundOpacity"
                        class="colorPicker"
                      >
                      </el-color-picker>
                      <jd-button
                        class="ml16"
                        type="blueText"
                        :disabled="backgroundOpacity"
                        @click="customerPaperwork.tabUnSelectedColor = currrentRgb3"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="奖品设置：">
                <div class="upload-box">
                  <el-form-item label="奖品名称背景色：">
                    <div class="flexc-cen-x">
                      <el-color-picker
                        v-model="customerPaperwork.prizeNameBgColor"
                        :disabled="backgroundOpacity"
                        class="colorPicker"
                      >
                      </el-color-picker>
                      <jd-button
                        class="ml16"
                        type="blueText"
                        :disabled="backgroundOpacity"
                        @click="customerPaperwork.prizeNameBgColor = currrentRgb4"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                  <el-form-item label="奖品名称文字色：">
                    <div class="flexc-cen-x">
                      <el-color-picker
                        v-model="customerPaperwork.prizeNameColor"
                        :disabled="backgroundOpacity"
                        class="colorPicker"
                      >
                      </el-color-picker>
                      <jd-button
                        class="ml16"
                        type="blueText"
                        :disabled="backgroundOpacity"
                        @click="customerPaperwork.prizeNameColor = currrentRgb5"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="按钮设置：">
                <div class="upload-box">
                  <el-form-item label="按钮背景图：">
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => beforeUploadUI(file, 2)"
                        :on-success="(res) => handleUploadUI(res, 2)"
                      >
                        <div class="bg-wrap" v-if="customerPaperwork.btnUrl">
                          <img
                            :src="customerPaperwork.btnUrl"
                            class="bg-wrap-img"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueLine"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.btnUrl = ''"
                        class="ml16"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                      <span class="size-tip">尺寸建议：450*128px</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="按钮文字色：">
                    <div class="flexc-cen-x">
                      <el-color-picker
                        v-model="customerPaperwork.btnColor"
                        :disabled="backgroundOpacity"
                        class="colorPicker"
                      >
                      </el-color-picker>
                      <jd-button
                        class="ml16"
                        type="blueText"
                        :disabled="backgroundOpacity"
                        @click="customerPaperwork.btnColor = currrentRgb6"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="消费报告设置：">
                <div class="upload-box">
                  <el-form-item label="消费报告背景图：">
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => beforeUploadUI(file, 3)"
                        :on-success="(res) => handleUploadUI(res, 3)"
                      >
                        <div
                          class="bg-wrap"
                          v-if="customerPaperwork.consumerReportUrl"
                        >
                          <img
                            :src="customerPaperwork.consumerReportUrl"
                            class="bg-wrap-img"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueLine"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.consumerReportUrl = ''"
                        class="ml16"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                      <span class="size-tip">尺寸建议：750*1650px</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="生成报告按钮图：">
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => beforeUploadUI(file, 4)"
                        :on-success="(res) => handleUploadUI(res, 4)"
                      >
                        <div
                          class="bg-wrap"
                          v-if="customerPaperwork.generateReportUrl"
                        >
                          <img
                            :src="customerPaperwork.generateReportUrl"
                            class="bg-wrap-img"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueLine"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.generateReportUrl = ''"
                        class="ml16"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                      <span class="size-tip">尺寸建议：330*78px</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="领取许愿币按钮图：">
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => beforeUploadUI(file, 5)"
                        :on-success="(res) => handleUploadUI(res, 5)"
                      >
                        <div class="bg-wrap" v-if="customerPaperwork.windUrl">
                          <img
                            :src="customerPaperwork.windUrl"
                            class="bg-wrap-img"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueLine"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.windUrl = ''"
                        class="ml16"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                      <span class="size-tip">尺寸建议：330*78px</span>
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="音效配置：">
                <el-radio-group v-model="customerPaperwork.musicOpen">
                  <el-radio :label="0">不开启</el-radio>
                  <el-radio :label="1">开启</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="背景音乐设置：" label-position="left">
                <div class="upload-box">
                  <el-form-item label="音乐设置：" label-width="auto">
                    <div class="flexc-cen-x">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :disabled="backgroundOpacity"
                        :show-file-list="false"
                        :before-upload="beforeUploadMusic"
                        :on-success="(res) => handleUploadMusic(res)"
                      >
                        <jd-button :disabled="backgroundOpacity" type="blueLine"
                          >自定义上传({{
                            customerPaperwork.musicUrl ? 1 : 0
                          }}/1)</jd-button
                        >
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.musicUrl = ''"
                        class="ml16"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                      <span class="size-tip">格式:MP3，大小5M以内</span>
                    </div>
                    <div>{{ customerPaperwork.musicUrl }}</div>
                  </el-form-item>
                  <el-form-item label="图标颜色：" label-width="auto">
                    <el-radio-group
                      v-model="customerPaperwork.iconColor"
                      label-width="auto"
                    >
                      <el-radio label="1">白色</el-radio>
                      <el-radio label="2">灰色</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="奖品剩余库存：">
                <el-radio-group v-model="customerPaperwork.stock">
                  <el-radio :label="0">不显示</el-radio>
                  <el-radio :label="1">显示（C端活动显示剩余库存）</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="无消费用户的回忆录文案："
                v-if="ruleDTO.showMemoryBook"
                label-width="auto"
              >
                <div class="copywriting">
                  <el-popover placement="right" width="270" trigger="hover">
                    <el-image
                      style="width: 100%"
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/consumption-report.jpg"
                      :preview-src-list="[
                        'https://cdn-image.yucrm.cn/images/jd-front-platform/images/consumption-report.jpg',
                      ]"
                    />
                    <jd-button slot="reference" type="blueText"
                      >文案示意图</jd-button
                    >
                  </el-popover>
                  <el-input
                    type="textarea"
                    style="width: 500px"
                    show-word-limit
                    maxlength="2000"
                    :rows="2"
                    :autosize="{ minRows: 4 }"
                    v-model="customerPaperwork.copywriting"
                    placeholder="请输入无消费用户的回忆录文案"
                  ></el-input>
                </div>
              </el-form-item>
            </template>
          </activityPageSettings>
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            @generateRule="generateRule"
            :activityData="activityData"
            :valueRow="valueRow"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button v-if="isSave" type="blue" @click="resetForm" v-preventReClick
          >保存设置</jd-button
        >
      </template>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  saveOrUpdateTimeWishPool,
  getTimeWishPoolDetail,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import wishingPoolDialog from "./components/newActPreviews/wishingPoolDialog.vue";
import taskComponent from "./components/_components/taskComponent.vue";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import newPrizeTable from "./components/newPrizeTable/index.vue";
import lotteryPrize from "./components/lotteryPrize/index.vue";
import {
  conditionValue,
  getTaskTypeOptions,
} from "./components/taskCommonField/index.js";
import {
  useInputTaskData,
  useOutputTaskData,
} from "./components/commDataHook/useTaskData.js";
import orderShopCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/orderShopCom.vue";
// import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

export default {
  components: {
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    taskComponent,
    newPrizeTable,
    lotteryPrize,
    wishingPoolDialog,
    orderShopCom,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mainText: "许愿币",
      unit: "枚",
      taskLevelList: [],
      drawStartTimeOptions: {
        disabledDate: (time) => {
          if(this.ruleDTO.drawEndTime) {
            return time.getTime() > new Date(this.ruleDTO.drawEndTime + " 23:59:59").getTime();
          } else {
            return false;
          }
        },
      },
      drawEndTimeOptions: {
        disabledDate: (time) => {
          if(this.ruleDTO.drawStartTime) {
            return time.getTime() < new Date(this.ruleDTO.drawStartTime + " 00:00:00").getTime();
          } else {
            return false;
          }
        },
      },
      isKeyActivity: 0,
      placementPosition: [],
      isForceRemind: 0,
      copyPrizeList: [],
      templateUrl:
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/%E6%97%B6%E5%85%89%E8%AE%B8%E6%84%BF%E6%B1%A0%E6%A8%A1%E6%9D%BF.psd",
      lvLoading: false,
      isAddPrize: true,
      minLimit: 1, //一个奖池最少奖品数
      isShowDeleteBtn: true, //是否显示删除按钮
      isShowMoveBtn: true, //是否显示移动按钮
      isShowIndex: true, //是否显示索引
      maxLimit: 7, //一个奖池最多奖品数
      isShowAddBtn: true, //是否显示添加按钮
      isShowLottery: false, //是否显示抽奖条件
      isShowTip: false, //是否显示提示
      wishingPrizeList: [
        {
          id: 1,
          sortOrder: 1,
          poolIndex: 1,
          poolName: "",
          consumeCoins: "",
          prizeSettingList: [
            // 奖项设置
            {
              index: 0,
              prizeType: 9,
              price: null,
              title: "谢谢参与",
              totalAmount: null,
              percentage: null,
              logo: "",
            },
            // {
            //   index: 1,
            //   prizeType: 9,
            //   price: null,
            //   title: "谢谢参与",
            //   totalAmount: null,
            //   percentage: null,
            //   logo: "",
            // },
            // {
            //   index: 2,
            //   prizeType: 9,
            //   price: null,
            //   title: "谢谢参与",
            //   totalAmount: null,
            //   percentage: null,
            //   logo: "",
            // },
            // {
            //   index: 3,
            //   prizeType: 9,
            //   price: null,
            //   title: "谢谢参与",
            //   totalAmount: null,
            //   percentage: null,
            //   logo: "",
            // },
          ],
        },
      ],
      celebrationTypeList: [
        {
          label: "入会周年当天",
          value: 1,
        },
        {
          label: "入会周年当周",
          value: 2,
        },
        {
          label: "入会周年当月",
          value: 3,
        },
        {
          label: "自定义",
          value: 4,
        },
      ],
      lvCoinList: [],
      timeList: [
        {
          label: "近30天",
          value: 1,
        },
        {
          label: "近60天",
          value: 2,
        },
        {
          label: "近90天",
          value: 3,
        },
        {
          label: "近180天",
          value: 4,
        },
        {
          label: "近一年",
          value: 5,
        },
      ],
      isShowUnit: false,
      copyTaskList: [],
      conditionValue: conditionValue,
      maxPrizeCount: 20,
      isShowAdd: true,
      hasSelectGoods: [],
      taskDataList: [],
      saveLoading: false,
      loading: false,
      templateObj: {},
      currrentRgb: "",
      currrentRgb2: "",
      currrentRgb3: "",
      currrentRgb4: "",
      currrentRgb5: "",
      currrentRgb6: "",
      customerPaperwork: {
        title: "许愿解锁庆典礼",
        desc: "消耗许愿币进行许愿，有概率获取心愿礼",
        titleColor: "",
        url: "",
        tabUrl: "",
        tabSelectedColor: "",
        tabUnSelectedColor: "",
        prizeNameBgColor: "",
        prizeNameColor: "",
        btnUrl: "",
        btnColor: "",
        consumerReportUrl: "",
        generateReportUrl: "",
        windUrl: "",
        musicOpen: 0,
        musicUrl: "",
        iconColor: "1",
        stock: 1,
        copywriting:
          "嘿，认识你真好。这30天，你可能只是默默路过，还没有带走心仪的宝贝。但我们记得你每一次的驻足、每一次的浏览。没关系，好东西值得慢慢挑选。",
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        isValidBlackList: 0,
      },
      sharePic: "https://cdn-image.yucrm.cn/hd/images/wish-share.png",
      ruleDTO: {
        drawValidityType: 0, // 抽奖有效期类型：0-活动期间内许愿成功都可抽奖,1-许愿成功后需在指定时间内抽奖
        drawStartTime: "", // 抽奖开始时间
        drawEndTime: "", // 抽奖结束时间
        lightingSettingType: 0, // 许愿池点亮设置：0-仅可点亮一次，1-可点亮多次
        customerPaperwork: "",
        cusTemplateJSON: "",
        plusObject: 0,
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "https://cdn-image.yucrm.cn/hd/images/wish-share.png",
        openCardStartTime: "",
        openCardEndTime: "", //庆典时间
        // 活动设置字段
        activityType: 1, //活动类型
        customActivityName: "", //庆典名称
        customActivityTime: "", //庆典时间
        showMemoryBook: true, //是否展示回忆录
        memoryBookTimeType: 1, //回忆录统计时间
        giftType: 2, //赠送许愿币
        unifiedCoins: "", //赠送许愿币数
        celebrationType: 2, //领奖有效期
        celebrationBeforeDays: "", //领奖有效期前天数
        celebrationAfterDays: "", //领奖有效期后天数
        gameTime: 60,
        gameScorePer: 10,
        // foreScoreTotal: 0,
        giveTimes: "",
        gameCntLimit: "",
        // 奖品字段
        prizeGetType: 0,
        prizeLimit: "",
        scoreLimit: "",
        oneDayMaxRewardNumber: "", // 每人每天最大中奖次数
        totalMaxRewardNumber: "", // 活动期间抽奖最多中奖次数
        venderIds: []
      },
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      prizeList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          exchangeScore: null, // 兑换分值
          singleAmount: "",
        },
      ],
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          singleMaxWin: null,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          singleMaxWin: null,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          singleMaxWin: null,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          singleMaxWin: null,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          singleMaxWin: null,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          singleMaxWin: null,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          singleMaxWin: null,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          singleMaxWin: null,
          percentage: null,
          memberBuyPercentage: null,
        },
      ],
      tableInfo: [
        {
          prop: "exchangeScore",
          label: "到达分值",
          slot: "scoreSlot",
          slotName: "scoreName",
          minWidth: 120,
        },
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
          minWidth: 100,
        },
        {
          label: "值",
          prop: "price",
          minWidth: 100,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
          minWidth: 200,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slot: "totalAmountSlot",
          minWidth: 120,
        },
        {
          label: "图片",
          prop: "logo",
          slot: "logoSlot",
          minWidth: 120,
        },
        {
          label: "操作",
          minWidth: "90px",
          prop: "operation",
          slot: "operationSlot",
          minWidth: 142,
        },
      ],
      vlTableInfo: [
        {
          prop: "levelName",
          label: "等级名称",
        },
        {
          label: "赠送许愿币",
          slot: "lvCoinSlot",
        },
      ],
      taskOrderList: [],
      pickerOption: {
        disabledDate: (time) => {
          //  在活动开始-结束时间范围内
          return (
            time.getTime() < new Date(this.activityStartTime).getTime() ||
            time.getTime() >
              new Date(this.activityEndTime).getTime() - 24 * 60 * 60 * 1000
          );
        },
      },
    };
  },
  computed: {
    venderId() {
      return this.$store.state.loginUserInfo.venderId;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isStartEdit() {
      return this.activityData.isStart;
    },
    taskTypeOptions() {
      return getTaskTypeOptions("许愿币", false, "枚");
    },
    commcelebrationTypeLList() {
      if (this.ruleDTO.activityType == 1) {
        return this.celebrationTypeList;
      } else {
        return [
          {
            value: 1,
            label: `${this.ruleDTO.customActivityName}当天`,
          },
          {
            value: 2,
            label: `${this.ruleDTO.customActivityName}当周`,
          },
          {
            value: 3,
            label: `${this.ruleDTO.customActivityName}当月`,
          },
          {
            value: 4,
            label: "自定义",
          },
        ];
      }
    },
    commWinText() {
      if (this.ruleDTO.activityType == 1) {
        return "入会周年";
      } else {
        return this.ruleDTO.customActivityName;
      }
    },
    backgroundImage() {
      return this.ruleDTO.cusTemplateJSON
        ? JSON.parse(this.ruleDTO.cusTemplateJSON).activityBgImg
        : this.templateObj.url;
    },
  },
  created() {
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
    this.ruleDTO.venderIds = [this.venderId];
  },
  mounted() {
    this.getLevel();
    this.buriedPoint(1, "时光许愿池", "互动管理", "互动活动");
  },

  methods: {
    handleActivityTypeChange(val) {
      this.ruleDTO.customActivityName = "";
      this.ruleDTO.customActivityTime = "";
    },
    addPrizeSetting(e, current) {
      this.wishingPrizeList[current].prizeSettingList.push({
        index: this.wishingPrizeList[current].prizeSettingList.length,
        prizeType: 9,
        price: null,
        title: "谢谢参与",
        totalAmount: null,
        percentage: null,
        logo: "",
        isAdd: true,
      });
    },
    deleteWishingPrize(index) {
      this.wishingPrizeList.splice(index, 1);
    },
    upWishingSetting(index) {
      this.wishingPrizeList[index] = this.wishingPrizeList.splice(
        index - 1,
        1,
        this.wishingPrizeList[index]
      )[0];
    },
    downWishingSetting(index) {
      this.wishingPrizeList[index] = this.wishingPrizeList.splice(
        index + 1,
        1,
        this.wishingPrizeList[index]
      )[0];
    },
    // 添加许愿池
    addWishingPrize() {
      if (this.wishingPrizeList.length >= 3) {
        this.$message({
          message: "最多只能添加3个许愿池",
          type: "warning",
        });
        return;
      }

      this.wishingPrizeList.push({
        id: new Date().getTime(),
        sortOrder: this.wishingPrizeList.length + 1,
        poolIndex: this.wishingPrizeList.length + 1,
        poolName: "",
        consumeCoins: "",
        isAdd: true,
        prizeSettingList: [
          // 奖项设置
          {
            index: 0,
            prizeType: 9,
            price: null,
            title: "谢谢参与",
            totalAmount: null,
            percentage: null,
            logo: "",
            isAdd: true,
          },
          // {
          //   index: 1,
          //   prizeType: 9,
          //   price: null,
          //   title: "谢谢参与",
          //   totalAmount: null,
          //   percentage: null,
          //   logo: "",
          //   isAdd: true,
          // },
          // {
          //   index: 2,
          //   prizeType: 9,
          //   price: null,
          //   title: "谢谢参与",
          //   totalAmount: null,
          //   percentage: null,
          //   logo: "",
          //   isAdd: true,
          // },
          // {
          //   index: 3,
          //   prizeType: 9,
          //   price: null,
          //   title: "谢谢参与",
          //   totalAmount: null,
          //   percentage: null,
          //   logo: "",
          //   isAdd: true,
          // },
        ],
      });
    },
    changecelebrationType(val) {
      this.ruleDTO.celebrationBeforeDays = "";
      this.ruleDTO.celebrationAfterDays = "";
    },
    changememoryBookTimeType(val) {
      let statisticText = {
        1: "30天",
        2: "60天",
        3: "90天",
      };
      // 检查是否包含任何天数格式
      const hasDays =
        this.customerPaperwork.copywriting.includes("30天") ||
        this.customerPaperwork.copywriting.includes("60天") ||
        this.customerPaperwork.copywriting.includes("90天");
      if (hasDays) {
        // 替换所有天数格式，包括带 # 和不带 # 的情况
        this.customerPaperwork.copywriting =
          this.customerPaperwork.copywriting.replace(
            /(30|60|90)天/g,
            `${statisticText[val]}`
          );
      }
    },
    changeShowMemory(val) {
      this.ruleDTO.memoryBookTimeType = 1;
      this.ruleDTO.unifiedCoins = ""
      this.lvCoinList.forEach(item => { 
        item.lvCoin = ""
      })
    },
    changeunifiedCoins(val) {
      this.ruleDTO.unifiedCoins = "";
    },
    compareTime(time) {
      return new Date(time).getTime();
    },
    customActivityTimeCompare(val) {
      return (
        this.compareTime(val) < this.compareTime(this.activityStartTime) ||
        this.compareTime(val) > this.compareTime(this.activityEndTime)
      );
    },
    handleDateChange(val) {
      if (val && this.customActivityTimeCompare(val)) {
        this.$message.warning("自定义时间需在活动时间范围内，请重新选择！");
        this.ruleDTO.customActivityTime = "";
      }
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    // 背景图上传校验
    async beforeUploadUI(file, type) {
      let sizeype = {
        1: {
          width: 216,
          height: 64,
        },
        2: {
          width: 450,
          height: 128,
        },
        3: {
          width: 750,
          height: 1650,
        },
        4: {
          width: 330,
          height: 78,
        },
        5: {
          width: 330,
          height: 78,
        },
      };
      const status = await this.imgchecked(
        file,
        sizeype[type].width,
        sizeype[type].height
      );
      if (!status) {
        return false;
      }
    },
    // 背景图上传图片
    handleUploadUI(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == 1) {
          this.customerPaperwork.tabUrl = res.data;
          this.$message.success("Tab选中背景图上传成功");
        } else if (type == 2) {
          this.customerPaperwork.btnUrl = res.data;
          this.$message.success("按钮背景图上传成功");
        } else if (type == 3) {
          this.customerPaperwork.consumerReportUrl = res.data;
          this.$message.success("消费报告背景图上传成功");
        } else if (type == 4) {
          this.customerPaperwork.generateReportUrl = res.data;
          this.$message.success("生成报告按钮图上传成功");
        } else if (type == 5) {
          this.customerPaperwork.windUrl = res.data;
          this.$message.success("领取许愿币按钮图上传成功");
        }
      }
    },
    async beforeUploadMusic(file, fileList, item) {
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".mp3"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("文件格式不符合要求，请重新上传");
        return Promise.reject();
      }
      const isLt3M = file.size < 1024 * 1024 * 5;
      if (!isLt3M) {
        this.$message.info("文件大小不符合要求，请重新上传");
        return Promise.reject();
      }
    },
    // 上传成功
    handleUploadMusic(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.customerPaperwork.musicUrl = res.data;
        this.$message.success("上传成功");
      }
    },
    initCustomizeData(row) {
      let configJson = row.configJson && JSON.parse(row.configJson);
      this.customerPaperwork.titleColor = row.rgb || "#ffffff";
      this.customerPaperwork.tabSelectedColor = row.rgb2 || "#A579DF";
      this.customerPaperwork.tabUnSelectedColor = row.rgb3 || "1";
      this.customerPaperwork.prizeNameBgColor = configJson.rgb4 || "1";
      this.customerPaperwork.prizeNameColor = configJson.rgb5 || "1";
      this.customerPaperwork.btnColor = configJson.rgb6 || "1";
      // this.customerPaperwork.musicUrl = configJson.customizeJson;
      this.customerPaperwork.iconColor = configJson.rgb7;
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
      this.currrentRgb3 = row.rgb3;
      this.currrentRgb4 = configJson.rgb4;
      this.currrentRgb5 = configJson.rgb5;
      this.currrentRgb6 = configJson.rgb6;
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.loading = false;
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        let obj = this.giftList[0];
        this.templateObj = obj;
        this.templateId = obj.id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        let configJson =
          this.templateObj.configJson &&
          JSON.parse(this.templateObj.configJson);
        this.currrentRgb = this.templateObj.rgb;
        this.currrentRgb2 = this.templateObj.rgb2;
        this.currrentRgb3 = this.templateObj.rgb3;
        this.currrentRgb4 = configJson.rgb4;
        this.currrentRgb5 = configJson.rgb5;
        this.currrentRgb6 = configJson.rgb6;
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      this.lvLoading = true;
      if (this.activityData.isStart) {
        this.lvLoading = false;
      }
      querymemberLevel()
        .then((res) => {
          this.lvLoading = false;
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
            this.lvCoinList.push({
              customerLevel: item.customerLevel,
              levelName: item.customerLevelName,
              lvCoin: "",
            });
          });
          this.getDetail();
        })
        .catch((res) => {});
    },
    getTimeText() {
      const winTextList = {
        1: "当天",
        2: "当周",
        3: "当月",
        4: `从${this.commWinText}前${this.ruleDTO.celebrationBeforeDays}天到${this.commWinText}后${this.ruleDTO.celebrationAfterDays}天`,
      };
      let costomText = `${this.commWinText}前${this.ruleDTO.celebrationBeforeDays}天到${this.commWinText}后${this.ruleDTO.celebrationAfterDays}天`;
      let winText = "";
      if (this.ruleDTO.activityType == 1) {
        if (this.ruleDTO.celebrationType != 4) {
          winText = `入会周年${winTextList[this.ruleDTO.celebrationType]}`;
        } else {
          winText = costomText;
        }
      } else {
        if (this.ruleDTO.celebrationType != 4) {
          winText = `${this.ruleDTO.customActivityTime}${
            this.ruleDTO.customActivityName
          }${winTextList[this.ruleDTO.celebrationType]}`;
        } else {
          winText = `${this.ruleDTO.customActivityTime}${costomText}`;
        }
      }
      return winText;
    },
    //生成规则
    generateRule() {
      let text1 = "抽奖有效期：",
        text2 = "玩法介绍：\n",
        text3 = "奖品数量有限，先到先得；",
        text4 =
          "若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）；",
        secondText = "\n二、【如何参与】",
        thirdText = "\n三、【注意事项】";
      const { firstText, precautions } = this.getCommonText(
        this.levelList,
        this.ruleForm,
        this.ruleDTO,
        this.actMember
      );
      // const winTextList = {
      //   1: "当天",
      //   2: "当周",
      //   3: "当月",
      //   4: `从${this.commWinText}前${this.ruleDTO.celebrationBeforeDays}天到${this.commWinText}后${this.ruleDTO.celebrationAfterDays}天`,
      // };
      // let costomText = `${this.commWinText}前${this.ruleDTO.celebrationBeforeDays}天到${this.commWinText}后${this.ruleDTO.celebrationAfterDays}天`;
      // let winText = "";
      // if (this.ruleDTO.activityType == 1) {
      //   if (this.ruleDTO.celebrationType != 4) {
      //     winText = `入会周年${winTextList[this.ruleDTO.celebrationType]}`;
      //   } else {
      //     winText = costomText;
      //   }
      // } else {
      //   if (this.ruleDTO.celebrationType != 4) {
      //     winText = `${this.ruleDTO.customActivityTime}${
      //       this.ruleDTO.customActivityName
      //     }${winTextList[this.ruleDTO.celebrationType]}`;
      //   } else {
      //     winText = `${this.ruleDTO.customActivityTime}${costomText}`;
      //   }
      // }
      if(this.ruleDTO.activityType == 1) {
        text1 += this.getTimeText();
      } else {
        if(this.ruleDTO.drawValidityType == 0) {
          text1 += "活动期间内许愿成功都可抽奖";
        } else {
          text1 += `许愿成功后在${this.ruleDTO.drawStartTime}~${this.ruleDTO.drawEndTime}期间内可进行抽奖`;
        }
      }
      let textMemoryist = [
        "完成不同任务，可获得许愿币，任务完成的越多，许愿币攒得越快～（具体奖励以页面展示为准）",
        `攒够许愿币后，去点亮许愿池！有${this.wishingPrizeList.length}个的许愿池任你选~点亮哪个，你说了算！${ this.ruleDTO.lightingSettingType == 1 ? "每个许愿池可点亮多次" : "每个许愿池仅能点亮1次"}~点亮1次获得1次抽奖机会`,
        `${this.ruleDTO.activityType == 1 ? "点亮许愿池后，你的好运会在您" +  this.getTimeText() + "自动开启！" : this.ruleDTO.drawValidityType == 0 ? "点亮许愿池后，你的好运即可开启！" : "点亮许愿池后，你的好运可在" + this.ruleDTO.drawStartTime+ "~" + this.ruleDTO.drawEndTime + "期间开启！" }`,
      ];
      if (this.ruleDTO.showMemoryBook) {
        textMemoryist.unshift("查看回忆录可获得许愿币");
      }
      text2 += textMemoryist
        .map((item, index) => `(${index + 1})${item}`)
        .join("\n");

      let Arr1 = [
        firstText,
        [secondText, text1, text2, text3, text4],
        [thirdText, precautions],
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "、" + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //活动对象限制
      if (
        this.actMember == 2 &&
        (!this.ruleForm.partner || this.ruleForm.partner.length == 0)
      ) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDTO.openCardStartTime || !this.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
      }

      // 活动类型校验
      if (this.ruleDTO.activityType == 2) {
        if (!this.ruleDTO.customActivityName) {
          this.$message.warning("请输入庆典名称");
          return;
        }
        if (this.ruleDTO.drawValidityType == 1 && (!this.ruleDTO.drawStartTime || !this.ruleDTO.drawEndTime)) {
          this.$message.warning("请选择抽奖有效期时间");
          return;
        }
        // if (!this.ruleDTO.customActivityTime) {
        //   this.$message.warning("请选择自定义时间");
        //   return;
        // }
        // if(this.customActivityTimeCompare(this.ruleDTO.customActivityTime)) {
        //   this.$message.warning("自定义时间需在活动时间范围内，请重新选择！");
        //   return
        // }
      }
      // 任务校验
      if (this.taskDataList.length == 0) {
        this.$message.warning("请添加任务");
        return;
      }
      // 赠送许愿币校验
      if (this.ruleDTO.showMemoryBook&&this.ruleDTO.giftType == 1 && !this.ruleDTO.unifiedCoins) {
        this.$message.warning("请输入赠送许愿币");
        return;
      }

      if (
        this.ruleDTO.celebrationType == 4 &&
        (!this.ruleDTO.celebrationBeforeDays ||
          !this.ruleDTO.celebrationAfterDays)
      ) {
        this.$message.warning("请输入领奖有效期");
        return;
      }
      let isTrue = false;
      let hasThankYou = false;
      const isFlag = this.wishingPrizeList.some((item) => {
        if (!item.poolName) {
          this.$message.warning("请输入许愿池名称");
          return true;
        }
        if (!item.consumeCoins) {
          this.$message.warning("请输入许愿币配置");
          return true;
        }
        isTrue = item.prizeSettingList.some((item) => {
          if (item.prizeType != 9) {
            return !item.totalAmount;
          }
        });
        if (isTrue) {
          this.$message.warning("请填写奖品总数！");
          return true;
        }
        if (item.prizeSettingList.every((item) => item.prizeType == 9)) {
          this.$message.warning("请选择奖品！");
          return true;
        }

        // 检查是否至少有一个谢谢参与奖品
        hasThankYou = this.prizeSettingList.some((item) => item.prizeType == 9);
        if (!hasThankYou) {
          this.$message.warning("奖品设置请至少保留1个谢谢参与!");
          return true;
        }
      });
      if (isFlag) {
        return;
      }

      if (!this.templateId) {
        return this.$message.warning("请选择活动模板");
      }
      // 公活动配置校验
      // if (!useValidateMoreActSet(this)) {
      //   return;
      // }
      // 小程序分享标题
      if (!this.ruleDTO.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDTO.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if (this.ruleForm.isExposureItem && this.itemListFor.length == 0) {
        this.$message.warning("请选择曝光商品");
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    async handleDialogCloseAnoth() {
      let ruleDTO = {
        ...this.ruleDTO,
        openCardFollow: this.ruleForm.openCardFollow,
        firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
        openCardBeforeDay: this.ruleForm.openCardBeforeDay,
        isForceRemind: this.isForceRemind,
        levelConfigs: {},
        wishPools: [],
      };
      console.log('ruleDTO',this.ruleDTO);
      
      let obj = {
        ...this.ruleForm,
        subType: 76,
        ruleDTO,
        pointActivityPrizeDTOList: [],
        taskList: [],
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        isValidBlackList: this.ruleForm.isValidBlackList,
      };
      // 将lvCoinList数组中的转换为 key/value 格式：key对应等级，value对应许愿币配置
      let lvCoinMap = {};
      this.lvCoinList.forEach((item) => {
        lvCoinMap[item.customerLevel] = item.lvCoin;
      });
      obj.ruleDTO.levelConfigs = lvCoinMap;
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO.openCardStartTime =
        this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime =
        this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";
      obj.ruleDTO.plusObject = this.ruleDTO.plusObject;
      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      //曝光商品集合设置
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.isExposureItem ? 1 : 0;
      obj.itemList = this.itemListFor;

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel =
        this.ruleForm.partner && this.ruleForm.partner.length
          ? this.ruleForm.partner.join(",")
          : "";

      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      delete obj.partner;
      delete obj.openCardFollow;
      delete obj.firstOpenCardTimeType;
      delete obj.openCardBeforeDay;
      // 奖品处理
      let prizeListCommon = [];
      this.wishingPrizeList.forEach((item, index) => {
        (item.sortOrder = index + 1), (item.poolIndex = index + 1);
      });
      obj.ruleDTO.wishPools = this.wishingPrizeList.map((item) => {
        return {
          sortOrder: item.sortOrder,
          poolIndex: item.poolIndex,
          poolName: item.poolName,
          consumeCoins: item.consumeCoins,
        };
      });
      this.wishingPrizeList.forEach((item) => {
        item.prizeSettingList.forEach((row) => {
          prizeListCommon.push({
            awardLevel: item.poolIndex,
            ...row,
          });
        });
      });
      obj.pointActivityPrizeDTOList = prizeListCommon;
      // 任务
      if (this.taskDataList.length) {
        obj.taskList = useInputTaskData(this.taskDataList);
      } else {
        obj.taskList = [];
      }
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: prizeListCommon
              .filter((item) => item.id)
              .map((item) => {
                return {
                  ...item,
                  prizeId: item.id,
                  title: item.title,
                };
              }),
            addPrizeDTOList: prizeListCommon
              .filter((item) => !item.id)
              .map((item) => {
                delete item.isAdd;
                return item;
              }),
            isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow ? 1 : 0,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            endTime: this.ruleForm.endTime,
            taskList: obj.taskList,
            isValidBlackList: obj.isValidBlackList,
          };
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          saveOrUpdateTimeWishPool(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
        getTimeWishPoolDetail({
          id: this.valueRow.id,
        })
          .then((res) => {
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              isExposureItem,
              ruleDescription,
              allowLevel,
              crowdIds,
              condFollow,
              templateId,
              pointActivityPrizeDTOList,
              taskList,
              isKeyActivity,
              placementPosition,
              isValidBlackList,
              studentSatus,
            } = res.data;
            const {
              openCardFollow,
              firstOpenCardTimeType,
              openCardBeforeDay,
              isForceRemind,
              wishPools,
              levelConfigs,
            } = ruleDto;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");
            this.ruleForm.condFollow = condFollow ? true : false;
            // 活动对象配置
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds.split(",");
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
              this.ruleForm.partner = ["-1"];
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            this.ruleForm.openCardFollow = openCardFollow;
            this.ruleForm.isValidBlackList = isValidBlackList
            this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
            this.ruleForm.openCardBeforeDay = openCardBeforeDay;
            // 学生身份
            this.ruleForm.studentSatus = studentSatus || "";
            this.ruleDTO = ruleDto;
            this.isForceRemind = isForceRemind;
            this.isKeyActivity = isKeyActivity||0;
            this.placementPosition = placementPosition ? placementPosition.split(",") : ["SHOP"];
            this.$set(this.ruleDTO, "drawValidityType", res.data.ruleDto.drawValidityType || 0);
            this.$set(this.ruleDTO, "lightingSettingType", res.data.ruleDto.lightingSettingType || 0);
            this.$set(this.ruleDTO, "drawStartTime", res.data.ruleDto.drawStartTime || "");
            this.$set(this.ruleDTO, "drawEndTime", res.data.ruleDto.drawEndTime || "");
            // 任务回显
            if (taskList.length > 0) {
              this.taskDataList = useOutputTaskData(taskList, this);
            }
            if (ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(ruleDto.customerPaperwork);
            }
            // 等级配置许愿币回显
            for (let key in levelConfigs) {
              if (levelConfigs.hasOwnProperty(key)) {
                // 找到对应等级的lvCoinList项并更新
                const index = this.lvCoinList.findIndex(
                  (item) => item.customerLevel == key
                );
                if (index !== -1) {
                  this.lvCoinList[index].lvCoin = levelConfigs[key];
                }
              }
            }
            this.templateJson = JSON.parse(res.data.templateJson);
            const wishPoolsPrize = wishPools.map((item, index) => {
                return {
                  id: new Date().getTime() + index,
                  ...item,
                  prizeSettingList:
                    pointActivityPrizeDTOList.filter(
                      (i) => i.awardLevel == item.poolIndex
                    ) || [],
                };
              });
            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              this.ruleForm.startTime = startTime;
              this.ruleForm.endTime = endTime;
              this.activityStartTime = startTime;
              this.activityEndTime = endTime;

              this.ruleForm.isExposureItem = isExposureItem ? true : false;
              this.itemListFor = res.data.itemList;
              this.ruleForm.ruleDescription = ruleDescription;
              //奖品回显
              this.wishingPrizeList = wishPoolsPrize
              // this.copyPrizeList = pointActivityPrizeDTOList
            } else {
              wishPoolsPrize.forEach((item) => {
                if(item.prizeSettingList.some((i) => i.prizeType == 3)) {
                  item.prizeSettingList = item.prizeSettingList.filter((it) => it.prizeType == 3)
                  item.prizeSettingList.forEach((v)=>delete v.id);
                } else {
                  item.prizeSettingList = [{
                    index: 0,
                    prizeType: 9,
                    price: null,
                    title: "谢谢参与",
                    totalAmount: null,
                    percentage: null,
                    logo: "",
                  }];
                }
              })
              this.wishingPrizeList = wishPoolsPrize
              this.ruleForm.ruleDescription = "";
            }
            this.templateId = templateId;
            this.getPolite();
          })
          .catch((res) => {});
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.game-givetips {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .upload-box {
    width: 500px;
    padding: 20px;
    background: #f4f6fa;
    border-radius: 4px 4px 4px 4px;
  }
  .buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
  }

  .bg-wrap {
    width: 80px;
    overflow: hidden;
    &-img {
      width: 100%;
      height: auto;
    }
  }

  .invite-box {
    position: relative;
    background-color: #f7f8fa;
    padding: 16px;
    border-radius: 8px;
    .move-btn {
      // position: absolute;
      // top: 16px;
      // right: 16px;
    }
  }

  .ml12 {
    margin-left: 12px;
  }

  .ml8 {
    margin-left: 8px;
  }
  .mr8 {
    margin-right: 8px;
  }

  .ml20 {
    margin-left: 20px;
  }

  .mlr8 {
    margin: 0 8px;
  }

  .w90 {
    width: 90px;
  }
  .w125 {
    width: 125px;
  }
  .w150 {
    width: 150px;
  }
  .w180 {
    width: 180px;
  }
  .w400 {
    width: 400px;
  }

  .tip-color {
    color: #666;
  }

  .logo-style {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .text-red {
    color: #ff4d4f;
  }
  .size-tip {
    color: #aaaaaa;
    margin-left: 8px;
  }
  .btn_boxs {
    background-color: rgb(248, 249, 252);
    padding: 16px;
    border-radius: 4px;
    width: 500px;
  }
  .limit {
    display: flex;
    align-items: center;
    color: #333333;
  }
  .label-color {
    color: #333333;
  }

  .copywriting {
    display: flex;
    flex-direction: column;
  }
}
.flex-c {
  display: flex;
  flex-direction: column;
}
/deep/ .el-tooltip__popper {
  font-size: 14px !important;
}
</style>
